import { useAppSelector } from "src/hooks/redux";
import { IMeeting } from "src/interfaces/IMeeting";



export const useRecordingHook = () => {
  const { recordings, recording, lastKey } = useAppSelector((state) => state.recording);
  const confirmDeletion = (meeting: IMeeting) => {
  }

  return {
    recordings,
    recording,
    lastKey,
    confirmDeletion
  };
}
